import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
	import { serverProps as state } from '@/Common/Environment/const';

	import MainView from '@/HostApp/ui/views/MainView.vue';

	
	const __default__ = {
		// eslint-disable-next-line vue/multi-word-component-names
		name: 'Viewport',
		inheritAttrs: false
	};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const computedWidth = computed(() => {
		if (state.isXSClientType) {
			return '100vw';
		} else {
			return '100%';
		}
	});

	const computedStyle = computed(() => {
		return {
			height: state.isXSClientType ? '100vh' : '100%',
			width: computedWidth.value
		};
	});

return { __sfc: true,computedWidth, computedStyle, MainView }
}

})